// extracted by mini-css-extract-plugin
export default {"Header":"styles_Header__BmFeI","keplrButton":"styles_keplrButton__5X3XE","keplrLogo":"styles_keplrLogo__TT5iV","arrow":"styles_arrow__a7iJ0"};